/**
 * 施設関係者グループ
 */
export default interface OtherUserGroup {
  /** 施設を特定するためのID */
  facilityId: number;
  /** {id}_{memberId}で作るソートキー */
  otherUserGroupsSortKey: string;
  /** グループを一意に識別する ID */
  id: number;
  /** グループ名 */
  name: string;
  /** グループの種類の ID。otherUserGroupTypes の id とひもづく */
  groupTypeId: number;
  /** グループ種類名 */
  groupTypeName: string;
  /** LineBot で初回登録で使用するパスワード。暗号化しない */
  password: string;
  /** メンバー数（メンバー数増減時に加算・減算する */
  memberCount: number;
  /** グループ内のメンバーを一意に識別する ID。グループの場合は 0、メンバーの場合は 1 以上 */
  memberId: number;
  /** メンバー名。グループの場合は NULL */
  memberName: string;
  /** メンバー電話番号。グループの場合は NULL */
  memberTel: string;
  /** メンバー所属。グループの場合は NULL */
  memberOrganization: string;
  /** メンバーのLINE の ID */
  memberLineId: string;
  /** メンバーのメッセージ最終投稿日時(YYYYMMDDhhmmssSSS) */
  memberMessageLatestDate: number;
  /** メンバーの最終投稿メッセージ内容（テキスト） */
  memberLatestMessage: string;
  /** 送信種別 */
  senderType: SenderType;
  /** メンバーメールアドレス */
  memberMailaddress?: string;
  /** LINE ユーザー登録の認証チェック用 */
  nonce: string;
  /** 施設関係者メンバーの機能使用可否 */
  otherUserPermittedFunctions: OtherUserPermittedFunctions;

  /** 削除フラグ */
  deleteFlag: boolean;
  /** レコード作成日 */
  created: number;
  /** レコード更新日 */
  updated: number;
}

export enum SenderType {
  /** LINE */
  LINE = 0,
  /** MAIL */
  MAIL = 1
}

export interface OtherUserPermittedFunctions {
  /** 空床情報 */
  vacancy: boolean;
}
